module.exports = __webpack_public_path__ + "media/images/report_areas/davesig-7bae0e15ec98c4e24ed86b43ae0482e5.png";